/**
 * Avisos críticos (auditoría del 2026-10-11, H-10): los que esperan una acción de quien los recibe saltan en una
 * franja fija bajo la cabecera y suenan; el resto sigue en la campana. El sonido se genera en el navegador (dos
 * tonos cortos): no hay archivos de audio ni servicios externos.
 */

/** Esperan una acción de quien los recibe: franja en pantalla + sonido. */
export const AVISOS_QUE_ESPERAN: ReadonlySet<string> = new Set([
  'autorizacion.solicitada',
  'caja.retiro_por_confirmar',
  'caja.retiro_excede',
  'caja.limite_efectivo',
  'control.por_agotarse',
]);
/** Solo suenan (la respuesta que el cajero espera en su pantalla). */
export const AVISOS_SONOROS: ReadonlySet<string> = new Set([...AVISOS_QUE_ESPERAN, 'autorizacion.aprobada', 'autorizacion.negada', 'caja.retiro_observado']);
/** Un aviso más viejo que esto ya no salta: queda en la campana. */
export const VIGENCIA_AVISO_MS = 12 * 3_600_000;

const CLAVE = 'mg.avisos.sonido';
export function sonidoActivo(): boolean {
  try {
    return localStorage.getItem(CLAVE) !== 'no';
  } catch {
    return true;
  }
}
export function guardarSonido(activo: boolean): void {
  try {
    localStorage.setItem(CLAVE, activo ? 'si' : 'no');
  } catch {
    // Sin almacenamiento local: el sonido queda activo
  }
}

let contexto: AudioContext | null = null;
let preparado = false;
/**
 * El navegador solo deja sonar después de que la persona tocó la página: el audio se crea con su primer clic o
 * tecla. Antes de eso el aviso salta igual, sin sonido.
 */
export function prepararSonido(): void {
  if (preparado || typeof window === 'undefined') return;
  preparado = true;
  const activar = () => {
    const Ctor = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (Ctor && !contexto) contexto = new Ctor();
    void contexto?.resume().catch(() => undefined);
  };
  window.addEventListener('pointerdown', activar, { passive: true });
  window.addEventListener('keydown', activar, { passive: true });
}

/** Dos tonos cortos. Devuelve si sonó (no suena silenciado ni antes del primer clic). */
export function sonarAviso(): boolean {
  if (!sonidoActivo() || !contexto || contexto.state !== 'running') return false;
  const c = contexto;
  const inicio = c.currentTime;
  for (const [espera, frecuencia] of [[0, 880], [0.24, 1175]] as const) {
    const osc = c.createOscillator();
    const gan = c.createGain();
    osc.type = 'sine';
    osc.frequency.value = frecuencia;
    gan.gain.setValueAtTime(0.0001, inicio + espera);
    gan.gain.exponentialRampToValueAtTime(0.25, inicio + espera + 0.02);
    gan.gain.exponentialRampToValueAtTime(0.0001, inicio + espera + 0.2);
    osc.connect(gan).connect(c.destination);
    osc.start(inicio + espera);
    osc.stop(inicio + espera + 0.22);
  }
  return true;
}
